import { formatDateRange } from '~/utils/dateFormatter';

export const useDateTranslation = () => {
  const { $i18n } = useNuxtApp();

  const getPromotionDuration = (duration) => {
    if (!duration) return '';
    const currentLocale = $i18n.locale || 'uk';
    const { startDate, endDate } = formatDateRange(duration, currentLocale);

    return $i18n.t('promotion.duration', {
      startDate,
      endDate,
    });
  };
  const getFormattedDates = (duration) => {
    if (!duration) return null;
    const currentLocale = $i18n.locale || 'uk';
    return formatDateRange(duration, currentLocale);
  };
  return {
    getPromotionDuration,
    getFormattedDates,
  };
};
